const retryFetch = require("../../utils/retry-fetch");

const securemaBaseUrl = CONFIG.securemaBaseUrl;
const market = CONFIG.iowsLocale;
const language = CONFIG.language;

const addToList = (payload) => {
  
  const productPostDataPayload = putPayload({
    itemType: payload.productType,
    itemNo: payload.productNumber,
    itemQty: payload.quantity,
  });

  const requestObject = getRequestObject({
    bagId: payload.listId,
    userId: payload.session.userId,
    payload: productPostDataPayload,
  });

  return retryFetch(
    3,
    1000,
    true
  )(requestObject.url, requestObject)
    .then(() => ({ status: "LIST_ADD_SUCCESS" }))
    .catch(() => ({ status: "LIST_ADD_FAIL" }));
};

const putPayload = (payload) => (
//   {
//   // BagType: "onlineshoppinglist",
//   // BagSource: "M2",
//   // BagName: payload.bagName,
//   // CustomerSource: "M2",
//   // CustomerId: userId,
//   // CreatedDateTime: new Date().toUTCString(),
//   // shoppingBagSectionList: [
//   //   {
//   //     shoppingBagItemList: [
//   //       {
//   //         itemType: payload.itemType.toUpperCase(),
//   //         itemNo: payload.itemNo,
//   //         itemQty: payload.itemQty,
//   //       },
//   //     ],
//   //   },
//   // ],
// }
[
  {
    itemType: payload.itemType.toUpperCase(),
    itemNo: payload.itemNo,
    itemQty: payload.itemQty,
  },
]
);

const getRequestObject = (state) => {
  
  return {
    method: "POST",
    headers: {
      Accept: "application/vnd.middleware-v1+json",
      Contract: CONFIG.iowsApiContract,
      Consumer: CONFIG.iowsApiConsumer,
      "Content-type": "application/json",

    },
    url: `${securemaBaseUrl}/${market}/customer/irw/${state.userId}/shoppingbags/onlineshoppinglist/${state.bagId}/items`,
    mode: "cors",
    cache: "default",
    credentials: "include",
    body:  JSON.stringify(state.payload),
  };
};

module.exports = addToList;
